import React from 'react'
import {BadgeContainer} from './style'

type TBadge = {
    totalCartProducts: number,
    color: string,
    isSelected?: boolean,
    isFooter?:boolean
}

const BadgeCounter = ({totalCartProducts, color, isSelected,isFooter=false}: TBadge  ) => {
    return (
        <BadgeContainer color={color} isSelected={isSelected} isFooter={isFooter} >
            {totalCartProducts}
        </BadgeContainer>
    )
}

export default BadgeCounter